import React from 'react';


const SvgSmallFooterRoller = ({ ...props }) => (
  <svg width="100%" height="100%" viewBox="0 0 375 952" fill="none" {...props}>
    <mask
      id="SmallFooterRoller_svg__a"
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={375}
      height={952}
    >
      <path fill="#fff" d="M0 0h375v952H0z" />
    </mask>
    <g mask="url(#SmallFooterRoller_svg__a)">
      <path
        d="M258.662 22.331l1.345 598.732H114V-.493L258.662 22.33z"
        fill="#fff"
      />
      <path
        d="M482.815-106.721L381.198 601.607l-183.92-26.835L300.59-133.309l182.225 26.588zM114.396-166.85l73.361 711.809-160.879 16.242L-45-150.758l159.396-16.092z"
        fill="#fff"
      />
      <path
        d="M189.686 735.826v86.823h-7.547V743.36H85v-81.676h38.557v7.534H92.622v66.608h97.064z"
        fill="#F1945F"
      />
      <path
        d="M190.583 934.384c0 2.238-1.868 4.103-4.11 4.103s-4.11-1.865-4.11-4.103a4.094 4.094 0 014.11-4.102c2.242.074 4.11 1.864 4.11 4.102zm-20.848-.895h.15c.149 9.249 7.771 16.708 17.111 16.708s16.887-7.459 17.112-16.708h.373V789.382h-34.746v144.107z"
        fill="#F1945F"
      />
      <path
        d="M259.626 636.547v57.211H115.338v-57.211h144.288zM114 0h206v175H114z"
        fill="#fff"
      />
    </g>
  </svg>
);

export default SvgSmallFooterRoller;
